import React, { createContext, useContext, useState } from 'react';
import { LojaContext } from '~/context/loja';
import {
  ItemFiscalProps,
  ManutencaoFiscalNfceContextData,
  ManutencaoFiscalNfceProviderProps,
} from './types';
import { GridRowParams } from '@material-ui/data-grid';
import { useForm } from 'react-hook-form';
import { getItensFiscal } from './services/getItensFiscal';
import moment from 'moment';

export const ManutencaoFiscalNfceContext = createContext(
  {} as ManutencaoFiscalNfceContextData,
);

export const ManutencaoFiscalNfceProvider: React.FC<
  ManutencaoFiscalNfceProviderProps
> = ({ children }) => {
  const { loja } = useContext(LojaContext);
  const [loader, setLoader] = useState<boolean>(false);
  const [update, setUpdate] = useState<boolean>(false);
  const [disabled, setDisabled] = useState<boolean>(true);
  const [showSearch, setShowSearch] = useState<boolean>(true);
  const [openNcmList, setOpenNcmList] = useState<boolean>(false);

  // Itens fiscal
  const [itensFiscal, setItensFiscal] = useState<ItemFiscalProps[]>([]);

  const {
    register,
    handleSubmit,
    control,
    setValue,
    getValues,
    setError,
    setFocus,
    clearErrors,
    formState,
    watch,
    reset,
    trigger,
  } = useForm({
    //    resolver: yupResolver(schema),
    reValidateMode: 'onBlur',
  });

  const [numNcm, setNumNcm] = useState<string>('');

  const handleResetForm = () => {
    setValue('num_ncm', '');
    setValue('id', '');
    setValue('cod_item', '');
    setNumNcm('');
    setDisabled(true);
  };

  const onRowClick = async (param: GridRowParams) => {
    const {
      num_pdv,
      cod_loja,
      dta_cupom,
      tipo_status,
      des_tipo_status,
      cod_seq_cupom,
    } = param.row;
    setValue('cod_seq_cupom', cod_seq_cupom);
    setValue('num_pdv', num_pdv);
    setValue('cod_loja', cod_loja);
    setValue('tipo_status', tipo_status);
    setValue('des_tipo_status', des_tipo_status);
    const formattedDta = moment(dta_cupom).format('DD/MM/YYYY HH:mm');
    setValue('dta_cupom', formattedDta);

    const itensFiscalNF = await getItensFiscal(Number(cod_seq_cupom));
    setItensFiscal(itensFiscalNF);
    setLoader(true);
    setUpdate(true);
    setShowSearch(false);
    setLoader(false);
  };

  const valuesProvider = {
    loja,
    showSearch,
    setShowSearch,
    loader,
    setLoader,
    update,
    setUpdate,
    itensFiscal,
    setItensFiscal,
    onRowClick,
    openNcmList,
    setOpenNcmList,
    numNcm,
    setNumNcm,
    disabled,
    setDisabled,
    formManutencaoFiscalNFCE: {
      watch,
      reset,
      control,
      register,
      setValue,
      setError,
      getValues,
      setFocus,
      formState,
      clearErrors,
      handleSubmit,
      trigger,
    },
    // funções
    handleResetForm,
  };
  return (
    <ManutencaoFiscalNfceContext.Provider value={valuesProvider}>
      {children}
    </ManutencaoFiscalNfceContext.Provider>
  );
};

export const useManutencaoFiscalNfce = (): ManutencaoFiscalNfceContextData => {
  return useContext(ManutencaoFiscalNfceContext);
};
